import { render, staticRenderFns } from "./QuoteServiceTemplateListPage.vue?vue&type=template&id=53c50a48&"
import script from "./QuoteServiceTemplateListPage.vue?vue&type=script&lang=ts&"
export * from "./QuoteServiceTemplateListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports